import { pluck, distinctUntilChanged } from 'rxjs/operators';

/**
 * @param {Observable<playback-web-player.Frame>} frameUpdate$
 * @return {Observable<boolean>}
 */

const createFullscreenStream = frameUpdate$ =>
    frameUpdate$
        .pipe(
            pluck('isFrameFullscreened'),
            distinctUntilChanged()
        );

export default createFullscreenStream;
